import {styled} from "@mui/material/styles"

// HF = Horizontal Filters
// VF = Vertical Filters

export const HFStyledIcon = styled("span")`
    min-width: 1.875rem;
    && > img {
        padding-top: 0.188rem;
    }
`
